import { styled } from '@linaria/react';

export const CardListHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    height: 80px;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 0.85rem;
    color: #2c3e50;
    border-bottom: 2px solid #dee2e6;
    background: #e9ecef;
    position: sticky;
    top: 0;
    z-index: 1;
    gap: 0.5rem;
    flex-shrink: 0;
`;

export const CardListHeaderTitle = styled.span`
    white-space: nowrap;
`;

export const CardListHeaderToggle = styled.button<{ $active?: boolean }>`
    background: ${(props) => (props.$active ? '#e2e6ea' : 'transparent')};
    border: 1px solid ${(props) => (props.$active ? '#adb5bd' : 'transparent')};
    color: #495057;
    cursor: pointer;
    padding: 0.2rem 0.5rem;
    border-radius: 3px;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: #e2e6ea;
        border-color: #adb5bd;
    }

    svg {
        font-size: 0.7rem;
    }
`;

export const CardListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: #f4f5f7;
`;

export const CardListContainer = styled.div`
    overflow-y: auto;
    flex: 1;
    min-height: 0;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
        &:hover {
            background: #a1a1a1;
        }
    }
`;

export const CardListEmptyMessage = styled.div`
    padding: 1.5rem 1rem;
    text-align: center;
    color: #6c757d;
    font-size: 0.85rem;
    font-style: italic;
`;

export const CardListLoadingMessage = styled.div`
    padding: 1.5rem 1rem;
    text-align: center;
    color: #6c757d;
    font-size: 0.85rem;
`;

export const CardItem = styled.div<{ $isActive?: boolean }>`
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    border-bottom: 1px solid #eef0f2;
    background: ${(props) => (props.$isActive ? '#e8f0fe' : 'transparent')};
    border-left: 3px solid ${(props) => (props.$isActive ? '#007bff' : 'transparent')};
    transition: background 0.15s ease;
    display: flex;
    align-items: center;
    gap: 0.6rem;

    &:nth-child(even) {
        background: ${(props) => (props.$isActive ? '#e8f0fe' : '#f8f9fb')};
    }

    &:hover {
        background: ${(props) => (props.$isActive ? '#e8f0fe' : '#eef1f5')};
    }
`;

export const CardItemContent = styled.div`
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const CardItemName = styled.div`
    font-size: 0.85rem;
    font-weight: 600;
    color: #495057;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CardItemIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    min-width: 20px;
`;

export const CardItemTypeIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    min-width: 20px;
    margin-left: auto;
`;

export const CardItemCategory = styled.div`
    font-size: 0.75rem;
    color: #8a939c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CardItemDetail = styled.div`
    font-size: 0.7rem;
    color: #adb5bd;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
